import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthContextProvider } from './contexts/AuthContext';
import { CartContextProvider } from './contexts/CartContext';
import { ThemeContextProvider } from './contexts/ThemeContext';
import { TransactionContextProvider } from './contexts/TransactionContext';
import { LandingBusinessContextProvider } from './contexts/LandingBusinessContext';
import { HomeEquityContextProvider } from './features/home-equity/context/HomeEquityContext';
import { ApiProvider } from './server/api';
import Routes from './routes';
import { RatingContextProvider } from './contexts/RatingContext';
import { PointsContextProvider } from './contexts/PointsContext';
import { KPIContextProvider } from './contexts/KPIContext';
import { EventsContextProvider } from './contexts/EventsContext';
import { PostValidationContextProvider } from './contexts/PostValidationContext';
import { IbgeContextProvider } from './contexts/IbgeContext';
import { StatementContextProvider } from './contexts/StatementContext';
import { QuizContextProvider } from './contexts/QuizContext';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthContextProvider>
          <ApiProvider>
            <ThemeContextProvider>
              <PointsContextProvider>
                <CartContextProvider>
                  <TransactionContextProvider>
                    <LandingBusinessContextProvider>
                      <HomeEquityContextProvider>
                        <EventsContextProvider>
                          <PostValidationContextProvider>
                            <IbgeContextProvider>
                              <RatingContextProvider>
                                <KPIContextProvider>
                                  <StatementContextProvider>
                                    <QuizContextProvider>
                                      <ToastContainer />
                                      <Routes />
                                    </QuizContextProvider>
                                  </StatementContextProvider>
                                </KPIContextProvider>
                              </RatingContextProvider>
                            </IbgeContextProvider>
                          </PostValidationContextProvider>
                        </EventsContextProvider>
                      </HomeEquityContextProvider>
                    </LandingBusinessContextProvider>
                  </TransactionContextProvider>
                </CartContextProvider>
              </PointsContextProvider>
            </ThemeContextProvider>
          </ApiProvider>
        </AuthContextProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
